// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__1nc0n","checkbox":"Checkbox_checkbox__3slF-","label":"Checkbox_label__3u7GI"};